import FilterTypes from 'redux/filters/types';
import request from 'utils/request';
import urls from 'utils/config';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import {
  fetchApplicationAdminLevelsSuccess,
  fetchApplicationAdminLevelsFailure,
  fetchAdminLevelsCoursesSuccess,
  fetchAdminLevelsCoursesFailure,
} from 'redux/filters/actions';

const { API_BASE_URL } = urls || {};

export function scheduleEmailReport(data) {
  const url = `${API_BASE_URL}/report-settings`;

  return request({
    method: 'post',
    url,
    data
  })
}

export function sendEmailReport(data) {
  const url = `${API_BASE_URL}/application-reports/send`;

  return request({
    method: 'post',
    url,
    data: { ...data, startDate: new Date().toISOString() }
  })
}

function* fetchApplicationAdminLevels({ payload: id }) {
  const url = `${API_BASE_URL}/applications/${id}/admin-level-items`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchApplicationAdminLevelsSuccess(response.raw));
  } else {
    yield put(fetchApplicationAdminLevelsFailure(response.message));
  }
}

function* onFetchApplicationAdminLevels() {
  yield takeLatest(
    FilterTypes.START_FETCH_APPLICATION_ADMIN_LEVELS,
    fetchApplicationAdminLevels
  );
}

function* fetchAdminLevelCourses({ payload: id }) {
  const url = `${API_BASE_URL}/courses/admin-level-item/${id}`;
  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchAdminLevelsCoursesSuccess(response.raw));
  } else {
    yield put(fetchAdminLevelsCoursesFailure(response.message));
  }
}

function* onFetchAdminLevelCourses() {
  yield takeLatest(
    FilterTypes.START_FETCH_ADMIN_LEVELS_COURSES,
    fetchAdminLevelCourses
  );
}

export function* filterSaga() {
  yield all([
    call(onFetchApplicationAdminLevels),
    call(onFetchAdminLevelCourses),
  ]);
}
